import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getAccounting } from './accounting.selectors';

const selectInvestors = createSelector(getAccounting, ({ investors }) => investors);

export const selectInvestorsValues = createSelector(selectInvestors, Object.values);

export const selectInvestorsOptions = createSelector(selectInvestorsValues, investors =>
  investors.map(investor => ({ value: investor.investorId, name: investor.name })),
);

export const selectFilteredInvestors = createSelector(
  getDebouncedSearchValue,
  selectInvestorsValues,
  searchItems(investor => [investor.name]),
);
